import { CookieCategoryService } from "@lib/strapi/services/components/cookies/cookieCategory.service";
import {
  StrapiCookieBannerDTO,
  CookieBannerDTO,
} from "@lib/strapi/dtos/content-types/cookieBanner.dto";
import { StrapiPages } from "@lib/strapi/pages";
import { StrapiResponse } from "@lib/strapi/dtos/core/response.dto";
import { StrapiRoutes } from "@lib/strapi/routes";
import { fetchAPI } from "@lib/strapi/fetch-api";
import { parseStrapiContent } from "@lib/strapi/content";

export class CookieBannerService {
  static async fromStrapi(
    dto: CookieBannerDTO,
    locale: string,
    strapiData?: StrapiCookieBannerDTO,
  ): Promise<CookieBannerDTO> {
    if (!strapiData) {
      return null;
    }
    if (dto == null) {
      dto = new CookieBannerDTO();
    }
    dto.heading = strapiData.heading;
    dto.prompt = await parseStrapiContent(strapiData.prompt);
    dto.acceptAllLabel = strapiData.acceptAllLabel;
    dto.rejectAllLabel = strapiData.rejectAllLabel;
    dto.savePreferencesLabel = strapiData.savePreferencesLabel;
    dto.policyLinkLabel = strapiData.policyLinkLabel;
    dto.policyLinkUrl = strapiData.policyLinkUrl;
    dto.categories = await Promise.all(
      (strapiData.categories ?? []).map(
        async (item) => await CookieCategoryService.fromStrapi(locale, item),
      ),
    );
    return dto;
  }

  static async fetchSingle(
    authToken: string,
    locale: string,
  ): Promise<CookieBannerDTO> {
    const token = (process.env.CMS_API_TOKEN || process.env.STRAPI_API_TOKEN);
    const urlParamsObject = { locale };
    const response: StrapiResponse<StrapiCookieBannerDTO> = await fetchAPI(
      StrapiRoutes.cookieBanner(),
      urlParamsObject,
      token,
    );
    const dto = new CookieBannerDTO();
    return response.data == null
      ? null
      : await CookieBannerService.fromStrapi(dto, locale, response.data);
  }
}
